(function () {
  'use strict';

  /* @ngdoc object
   * @name requestRespectedReport
   * @description
   *
   */
  angular
    .module('requestRespectedReport', [
      'ui.router'
    ]);
}());
